import { useEffect, useRef, useState } from 'react';
import { useController } from 'react-hook-form';
import { Input, InputGroup } from 'rsuite';
import { FormGroup } from '@shared/ui/forms/display';
import { icons } from '@shared/static/icons';
import { copyToClipboard } from '@utils/helpers';
import { Avatar } from '@shared/ui/parts';

export default function BasicInput({
  error,
  control,
  name,
  isRequired = true,
  placeholder,
  validation,
  label,
  icon,
  counter,
  disabled = false,
  copyable = false,
  onButtonClick,
  buttonIcon,
}) {
  const { field } = useController({
    control,
    name,
    rules: {
      required: isRequired,
      ...(validation && {
        validate: (value) => validation(value, counter),
      }),
    },
  });
  const [isCopied, setIsCopied] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const team = field.value?.avatar ? field.value : null;
  const text =
    (typeof field.value === 'object' ? field.value?.name : field.value) ?? '';
  const hasButton = copyable || Boolean(onButtonClick);

  function copyValue() {
    copyToClipboard(field.value);
    setIsCopied(true);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setIsCopied(false), 1000);
  }

  return (
    <FormGroup
      error={error}
      label={label}
      counter={counter && <span>{text.length} / 25</span>}
    >
      <InputGroup
        inside
        className={`${field.value ? 'has-value' : ''} ${hasButton && disabled ? 'custom-disabled' : ''}`}
        disabled={disabled && !hasButton}
      >
        {(icon || team) && (
          <InputGroup.Addon className="start-addon">
            {icon ? icons[icon] : <Avatar team={team} />}
          </InputGroup.Addon>
        )}
        <Input
          value={text}
          placeholder={placeholder}
          onChange={field.onChange}
          disabled={disabled && hasButton}
        />
        {copyable && (
          <InputGroup.Button onClick={copyValue}>
            {isCopied ? icons.check : icons.copy}
          </InputGroup.Button>
        )}
        {onButtonClick && (
          <InputGroup.Button className="clickable" onClick={onButtonClick}>
            {icons[buttonIcon]}
          </InputGroup.Button>
        )}
      </InputGroup>
    </FormGroup>
  );
}
